import { render, staticRenderFns } from "./language-boxes.vue?vue&type=template&id=70400f73&"
import script from "./language-boxes.vue?vue&type=script&lang=js&"
export * from "./language-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports